module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.8882/img/storefront-header-blobs.svg"